import { render, staticRenderFns } from "./indexView.vue?vue&type=template&id=5afd7105&"
import script from "./indexView.vue?vue&type=script&lang=js&"
export * from "./indexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports